import React from 'react';

const NoDataSource = () => {
  return <div>No data source</div>;
};

export default NoDataSource;
